import { useMemo, useEffect, useState } from "react";

import PropTypes from "prop-types";

import { useTable, usePagination, useGlobalFilter, useAsyncDebounce, useSortBy } from "react-table";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Icon from "@mui/material/Icon";
import Autocomplete from "@mui/material/Autocomplete";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDPagination from "components/MDPagination";
import { makeStyles } from "@mui/styles";

import DataTableHeadCell from "ui/Tables/DataTable/DataTableHeadCell";
import DataTableBodyCell from "ui/Tables/DataTable/DataTableBodyCell";
import { IconButton } from "@mui/material";
import SyncIcon from "@mui/icons-material/Sync";
import { PAGINATION_SIZE } from "constant";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  hoverRow: {
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
});
function DataTable({
  entriesPerPage,
  canSearch,
  showTotalEntries,
  table,
  pagination,
  isSorted,
  noEndBorder,
  handleSearch,
  refreshData,
  isServerPagination,
  totalCount,
  listFilterData,
  filterRemoteData,
  resetPagination,
}) {
  // const defaultValue = entriesPerPage.defaultValue ? entriesPerPage.defaultValue : 10;
  const defaultValue = PAGINATION_SIZE;
  const entries = entriesPerPage.entries
    ? entriesPerPage.entries.map((el) => el.toString())
    : ["5", "10", "15", "20", "25"];
  // const columns = useMemo(() => table.columns, [table]);
  // const data = useMemo(() => table.rows, [table]);
  const columns = useMemo(() => table.columns, [table.columns]);
  const data = useMemo(() => table.rows, [table.rows]);

  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
      manualPagination: isServerPagination,
      pageCount: isServerPagination ? Math.ceil(totalCount / defaultValue) : undefined,
      autoResetPage: false,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
    page,
    pageOptions,
    canPreviousPage,
    canNextPage,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setGlobalFilter,
    state: { pageIndex, pageSize, globalFilter },
  } = tableInstance;

  useEffect(() => setPageSize(defaultValue || 10), [defaultValue]);
  useEffect(() => {
    if (resetPagination) {
      gotoPage(0);
    }
  }, [resetPagination]);
  /* useEffect(() => {
    if (listFilterData?.length === 0) {
      gotoPage(0);
    }
  }, [listFilterData]); */
  // console.log("sss ", pageIndex, pageSize, resetPagination);
  const setEntriesPerPage = (value) => setPageSize(value);
  useEffect(() => {
    // console.log("oo ", pageIndex, pageSize, globalFilter);
    if (isServerPagination) {
      // console.log("listFilterData", listFilterData);
      if (listFilterData?.length > 0) {
        filterRemoteData(listFilterData, pageIndex, pageSize);
      } else {
        refreshData(pageIndex, pageSize);
      }
      // refreshData(pageIndex, pageSize);
    }
  }, [pageIndex, pageSize /* , globalFilter */, isServerPagination]);

  const handleRefresh = () => {
    if (isServerPagination) {
      gotoPage(0);
      refreshData(pageIndex, pageSize);
    } else {
      refreshData();
    }
  };

  const renderPagination = pageOptions.map((option) => (
    <MDPagination
      item
      key={option}
      onClick={() => gotoPage(Number(option))}
      active={pageIndex === option}
    >
      {option + 1}
    </MDPagination>
  ));

  const handleInputPagination = ({ target: { value } }) =>
    value > pageOptions.length || value < 0 ? gotoPage(0) : gotoPage(Number(value));

  const customizedPageOptions = pageOptions.map((option) => option + 1);

  const handleInputPaginationValue = ({ target: value }) => gotoPage(Number(value.value - 1));

  const [search, setSearch] = useState(globalFilter || "");

  const onSearchChange = useAsyncDebounce((value) => {
    // console.log("uus", value);
    setGlobalFilter(value || undefined);
    handleSearch(value);
  }, 300);

  // A function that sets the sorted value for the table
  const setSortedValue = (column) => {
    let sortedValue;

    if (isSorted && column.isSorted) {
      sortedValue = column.isSortedDesc ? "desc" : "asce";
    } else if (isSorted) {
      sortedValue = "none";
    } else {
      sortedValue = false;
    }

    return sortedValue;
  };

  const entriesStart = pageIndex === 0 ? pageIndex + 1 : pageIndex * pageSize + 1;

  let entriesEnd;

  if (pageIndex === 0) {
    // entriesEnd = pageSize;
    entriesEnd = rows.length < pageSize ? rows.length : pageSize;
    //  console.log("hee", rows.length, );
  } else if (pageIndex === pageOptions.length - 1) {
    // console.log("hee", pageIndex === pageOptions.length - 1);

    entriesEnd = isServerPagination ? totalCount : rows.length;
  } else {
    entriesEnd = pageSize * (pageIndex + 1);
  }
  // console.log("ss", pageIndex, pageSize, pageOptions.length - 1);

  const classes = useStyles();
  const total = isServerPagination ? totalCount : rows.length;
  return (
    <TableContainer sx={{ boxShadow: "none" }}>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" pl={3} pr={3}>
        <MDBox display="flex" alignItems="center" sx={{ marginRight: 0 }}>
          <IconButton
            size="small"
            disableRipple
            color="inherit"
            aria-controls="notification-menu"
            aria-haspopup="true"
            variant="contained"
            // onClick={() => (isServerPagination ? refreshData(pageIndex, pageSize) : refreshData())}
            onClick={handleRefresh}
          >
            <SyncIcon fontSize="small" style={{ color: "gray" }} />
          </IconButton>
        </MDBox>
        <MDTypography variant="caption" color="secondary">
          {total} résultat(s)
        </MDTypography>
        {/* {rows?.length > 0 && (entriesPerPage || canSearch) && ( */}
        {(entriesPerPage || canSearch) && (
          <MDBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
            {canSearch && !isServerPagination && (
              <MDBox width="12rem" ml="auto" sx={{ marginRight: 5 }}>
                <MDInput
                  placeholder="Rechercher..."
                  value={search}
                  size="small"
                  fullWidth
                  /* onChange={({ currentTarget }) => {
                    // console.log("uus", currentTarget.value);
                    const { value } = currentTarget;
                    setSearch(value);
                    onSearchChange(value);
                    handleSearch(value);
                  }} */
                  onChange={({ currentTarget }) => {
                    setSearch(currentTarget.value);
                    onSearchChange(currentTarget.value);
                  }}
                />
              </MDBox>
            )}
            {entriesPerPage && canSearch === "ed" && (
              <MDBox display="flex" alignItems="center" sx={{ marginRight: 5 }}>
                <Autocomplete
                  disableClearable
                  value={pageSize.toString()}
                  options={entries}
                  onChange={(event, newValue) => {
                    setEntriesPerPage(parseInt(newValue, 10));
                  }}
                  size="small"
                  sx={{ width: "5rem" }}
                  renderInput={(params) => <MDInput {...params} />}
                />
                <MDTypography variant="caption" color="secondary">
                  &nbsp;&nbsp;lignes par page
                </MDTypography>
              </MDBox>
            )}
          </MDBox>
        )}
      </MDBox>
      <Table {...getTableProps()}>
        <MDBox component="thead">
          {headerGroups.map((headerGroup) => (
            <TableRow {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <DataTableHeadCell
                  {...column.getHeaderProps(isSorted && column.getSortByToggleProps())}
                  width={column.width ? column.width : "auto"}
                  align={column.align ? column.align : "left"}
                  sorted={setSortedValue(column)}
                >
                  {column.render("Header")}
                </DataTableHeadCell>
              ))}
            </TableRow>
          ))}
        </MDBox>
        <TableBody {...getTableBodyProps()}>
          {page.map((row, key) => {
            prepareRow(row);
            return (
              <TableRow {...row.getRowProps()} className={classes.hoverRow}>
                {row.cells.map((cell) => (
                  <DataTableBodyCell
                    noBorder={noEndBorder && rows.length - 1 === key}
                    align={cell.column.align ? cell.column.align : "left"}
                    {...cell.getCellProps()}
                  >
                    {cell.render("Cell")}
                  </DataTableBodyCell>
                ))}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>

      <MDBox
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        p={!showTotalEntries && pageOptions.length === 1 ? 0 : 3}
      >
        {showTotalEntries && rows?.length > 0 && (
          <MDBox mb={{ xs: 3, sm: 0 }}>
            <MDTypography variant="button" color="secondary" fontWeight="regular">
              De {entriesStart} à {entriesEnd} sur {total} lignes
            </MDTypography>
          </MDBox>
        )}
        {pageOptions.length > 1 && (
          <MDPagination
            variant={pagination.variant ? pagination.variant : "gradient"}
            color={pagination.color ? pagination.color : "info"}
          >
            {canPreviousPage && (
              <MDPagination item onClick={() => previousPage()}>
                <Icon sx={{ fontWeight: "bold" }}>chevron_left</Icon>
              </MDPagination>
            )}
            {renderPagination.length > 6 ? (
              <MDBox width="5rem" mx={1}>
                <MDInput
                  inputProps={{
                    type: "number",
                    min: 1,
                    max: customizedPageOptions.length,
                    style: { textAlign: "center" },
                  }}
                  value={customizedPageOptions[pageIndex]}
                  onChange={(handleInputPagination, handleInputPaginationValue)}
                  sx={{
                    "& input[type=number]::-webkit-inner-spin-button, & input[type=number]::-webkit-outer-spin-button":
                      {
                        opacity: 1,
                      },
                  }}
                />
              </MDBox>
            ) : (
              renderPagination
            )}
            {canNextPage && (
              <MDPagination item onClick={() => nextPage()}>
                <Icon sx={{ fontWeight: "bold" }}>chevron_right</Icon>
              </MDPagination>
            )}
          </MDPagination>
        )}
      </MDBox>
    </TableContainer>
  );
}

DataTable.defaultProps = {
  entriesPerPage: { defaultValue: 10, entries: [5, 10, 15, 20, 25] },
  canSearch: false,
  showTotalEntries: true,
  pagination: { variant: "gradient", color: "info" },
  isSorted: true,
  noEndBorder: false,
  handleSearch: () => {},
  refreshData: () => {},
  isServerPagination: false,
  totalCount: 0,
  listFilterData: [],
  filterRemoteData: () => {},
  resetPagination: false,
};

DataTable.propTypes = {
  entriesPerPage: PropTypes.oneOfType([
    PropTypes.shape({
      defaultValue: PropTypes.number,
      entries: PropTypes.arrayOf(PropTypes.number),
    }),
    PropTypes.bool,
  ]),
  canSearch: PropTypes.bool,
  showTotalEntries: PropTypes.bool,
  table: PropTypes.objectOf(PropTypes.array).isRequired,
  pagination: PropTypes.shape({
    variant: PropTypes.oneOf(["contained", "gradient"]),
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "light",
    ]),
  }),
  isSorted: PropTypes.bool,
  noEndBorder: PropTypes.bool,
  handleSearch: PropTypes.func,
  refreshData: PropTypes.func,
  isServerPagination: PropTypes.bool,
  totalCount: PropTypes.number,
  listFilterData: PropTypes.array,
  filterRemoteData: PropTypes.func,
  resetPagination: PropTypes.bool,
};

export default DataTable;
